/**
 * @file The one place a `/patient/form` link is built.
 * @module utils/forms/patientFormLink
 *
 * Every tokenised patient link comes from here, because a patient only ever sees whichever
 * copy reached them and they must all be the same URL.
 *
 * ⚠️ **Corrected at F11.** This used to name three call sites — `AssignFormModal`,
 * `FormsTab` and `FormsInTrayPage`. None of those three call this function any more. All
 * four **notification** sites now go through `utils/forms/formAssignedNotification`, which
 * is the one place the `form_assigned_notification` payload (and therefore `form_link`) is
 * built; this module's only direct callers are the two that need a URL rather than a
 * payload — `HandoverExitGuard` (F10, same-tab navigation) and `FormShareLinkModal` (F11,
 * the QR).
 *
 * ⚠️ THE TOKEN IS OMITTED WHEN ABSENT, NEVER INTERPOLATED AS `undefined`.
 * healthcare's `EnsureFormAccessToken` forgives a MISSING token while
 * `forms.require_access_token` is false (the grace period), but never forgives a WRONG one —
 * so a literal `&t=undefined` would be strictly worse than no token at all: an immediate 404
 * on a link that would otherwise have worked.
 */

import { ENV } from '../../config/runtimeEnv';

export const buildPatientFormLink = (
	assignedFormId: number | string,
	accessToken?: string | null,
): string => {
	const url = `${ENV.VITE_FRONTEND_BASE_URL}/patient/form?id=${assignedFormId}`;

	return accessToken ? `${url}&t=${encodeURIComponent(accessToken)}` : url;
};
